import { render } from "./HeaderBlockProfile.vue?vue&type=template&id=3697b334&scoped=true"
import script from "./HeaderBlockProfile.vue?vue&type=script&lang=js"
export * from "./HeaderBlockProfile.vue?vue&type=script&lang=js"

import "./HeaderBlockProfile.vue?vue&type=style&index=0&id=3697b334&scoped=true&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3697b334"]])

export default __exports__